module.exports = __webpack_public_path__ + "static/media/Madfit-6.4ac12807.jpg";